<script setup>
  import { computed } from 'vue'
  import { useStore } from 'vuex'

  const store = useStore()
  // const isFullScreen = computed(() => store.state.isFullScreen)
  const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
</script>

<template>
  <!-- :class="[ isFullScreen ? 'flex h-screen items-center justify-center' : 'py-6' ]" -->
  <!-- <section class="main-section" :class="{'main-section-full flex h-screen items-center justify-center' : isFullScreen}"> -->
  <section class="main-section" :class="{'main-section-full' : isAsideMobileExpanded}">
    <slot />
  </section>
</template>
